export class VaultEncryptionTypeFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<VaultEncryptionType>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<VaultEncryptionType>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return VaultEncryptionTypeFilters.attributeTypeMap;
    }
    constructor() {
    }
}
